import React from "react";
import "./Error404.scss";

export default function Error404() {
  return (
    <div>
      <h1 className="error"> Error404...</h1>
    </div>
  );
}
